import { Box } from '@mui/material'
import Grid from '@mui/material/Grid'
import Head from 'next/head'

export interface GuestLayoutProps {
  children: any
  title?: string
}

const APP_NAME = 'HeartLung.AI Patient Portal'

const GuestLayout = ({ children, title }: GuestLayoutProps) => {
  const pageTitle = title ? `${APP_NAME} - ${title}` : APP_NAME

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100wh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Head>
        <title>{pageTitle}</title>
      </Head>

      <Grid>{children}</Grid>
    </Box>
  )
}

export default GuestLayout
